/**
 * Action types
 */

import { createTypes } from 'reduxsauce'
import { IComponentState } from '../root.types'
// import { IComponentState, IPaginator, ISearch } from '../root.types'

export const ReportTypes = createTypes(`

    LOAD_REPORT_REQUEST
    LOAD_REPORT_SUCCESS
    LOAD_REPORT_FAILURE
   
`,
    {
        prefix: '@report/'
    }
)

/**
 * State type
 */
export interface IReportState {
    readonly create: ICreateState
    readonly filter: IFilter
}

export interface ICreateState extends IComponentState {
    readonly registered_patients: number
    readonly follow_ups_total: number
    readonly average_age: number
    readonly standard_deviation: number
    readonly state: GenericObject[]
    readonly county: GenericObject[]
    readonly age_list: GenericObject[]
    readonly case_type: GenericObject[]
    readonly risk_factors: GenericObject[]
    readonly stage_types: GenericObject[]
}
export interface IFilter {
    readonly primaryDate?: string
    readonly secondaryDate?: string
    readonly state?:string
    readonly addressCity?: string
}
export interface GenericObject {
    readonly name: string
    readonly value: number
}